import { startTransition } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

import './App.css';
import './instrumentation';

// Invite flow: User clicks link from email → B2C authorize URL (e.g. b2clogin.com/.../authorize?redirect_uri=dev.b1link.com&id_token_hint=...).
// When id_token_hint is expired, B2C does not complete sign-up; it redirects to redirect_uri with error in the hash:
//   https://dev.b1link.com/#error=invalid_request&error_description=AADB2C90208%3a+The+provided+id_token_hint+parameter+is+expired...
// We detect that and redirect to /invite-expired so the user sees a friendly page instead of a blank or raw error.
if (typeof globalThis !== 'undefined') {
  const hash = globalThis?.location?.hash;
  if (hash) {
    const lowerHash = hash.toLowerCase();
    const isInvalidRequest = lowerHash.includes('error=invalid_request');
    const isExpiredTokenError =
      lowerHash.includes('aadb2c90208') ||
      (lowerHash.includes('id_token_hint') && lowerHash.includes('expired'));
    if (isInvalidRequest && isExpiredTokenError) {
      globalThis?.location?.replace(`${globalThis?.location?.origin}/invite-expired`);
    }
  }
}

startTransition(() => {
  // createRoot(document) replaces <head> and drops Vite-injected styles; hydrateRoot keeps shell + RR <Links /> in sync.
  hydrateRoot(document, <HydratedRouter />);
});
